import type { Feature } from '@luna/gatekeeper';

export const creditCardLimitChange: Feature = {
    enabled: false,
    _description:
        'Displays credit card limit change in credit card features page and supplementary settings page - supported by AT only',
};
